import * as React from "react";
import { Stack } from "./Stack";
import { HSplit } from "./HSplit";
import { VSplit } from "./VSplit";
import { ProjectedWindowPortal } from "./WindowPortal";
import { List } from "./List";
var StackComponentFactory = function (comp) {
    return React.createElement(Stack, { stack: comp });
};
var HSplitComponentFactory = function (comp) {
    return React.createElement(HSplit, { hsplit: comp });
};
var VSplitComponentFactory = function (comp) {
    return React.createElement(VSplit, { vsplit: comp });
};
var WindowComponentFactory = function (comp) {
    return React.createElement(ProjectedWindowPortal, { window: comp });
};
var ListComponentFactory = function (comp) {
    return React.createElement(List, { stack: comp });
};
var ComponentFactoryMap = {
    stack: StackComponentFactory,
    hsplit: HSplitComponentFactory,
    vsplit: VSplitComponentFactory,
    window: WindowComponentFactory,
    list: ListComponentFactory
};
var ComponentFactory = function (comp) {
    if (comp) {
        var f = ComponentFactoryMap[comp.type];
        if (f) {
            return f(comp);
        }
    }
    return null;
};
export { ComponentFactory as default, ComponentFactory };
